import React, {useCallback, useEffect, useMemo} from "react";
import {EducationModifyProps} from "../types";
import {
    getUserWorksDetail,
    postUserWorksModify,
    postUserWorksSubmit,
    removeUserEducationById,
    removeUserWorkById
} from "../../service";
import useForm from "rc-form-hooks";
import Input from "../../components/inputItem";
import DatePickerBox from "./datePicker";
import {useHistory, useParams} from "react-router-dom";
import {getUserStorage} from "../../units";
import {useLoading} from "../../components/loading/LoadingProvider";
import {useModal} from "../../components/modal";

const dateConfig = {
    'year': {
        format: 'YYYY',
        caption: '年',
        step: 1,
    },
    'month': {
        format: 'M',
        caption: '月',
        step: 1,
    },
}

const WorkModal = () => {

    const params = useParams<{ id?:string }>()
    const userData = getUserStorage()
    const loading = useLoading()
    const his = useHistory()
    const modal = useModal()

    const {getFieldDecorator, validateFields, errors, values, setFieldsValue} = useForm<{
        company: string,
        post: string,
        content: string,
        start: string,
        end: string
    }>();


    const deleteHandle = (id:string) => {
        if(userData){
            modal.show({
                content:'是否删除该简历?',
                success(res){
                    if(res.confirm){
                        loading.showLoading()
                        removeUserWorkById({
                            userId:userData.id,
                            workId :id
                        }).then(res => {
                            if(res.code === 1){
                                loading.showSuccess('删除成功',() => {
                                    his.goBack()
                                })
                            }else{
                                loading.showError(res.msg)
                            }
                        })
                    }
                }
            })

        }
    }

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        if(userData){
            validateFields().then((_values) => {
                if(!params.id){
                    loading.showLoading('请求中...')
                    postUserWorksSubmit({
                        userId:userData.id,
                        ..._values
                    }).then(res => {
                        if(res.code === 1){
                            loading.showSuccess('添加成功',() => {
                                his.goBack()
                            })
                        }else{
                            loading.showError(res.msg)
                        }
                    })
                }else{
                    loading.showLoading('请求中...')
                    postUserWorksModify({
                        userId:userData.id,
                        workId:params.id,
                        ..._values
                    }).then(res => {
                        if(res.code === 1){
                            loading.showSuccess('修改成功',() => {
                                his.goBack()
                            })
                        }else{
                            loading.showError(res.msg)
                        }
                    })
                }
            })
        }
    }

    useEffect(() =>{
        if(params.id && userData){
            loading.showLoading()
            getUserWorksDetail({
                workId:params.id,
                userId:userData.id
            }).then(res => {
                if(res.code === 1){
                    setFieldsValue(res.data)
                }
                loading.hideLoading()
            }).catch(e => {
                loading.showError('请求失败')
            })
        }
    },[params])


    return <div className='education-modal' style={{ paddingTop:'.2rem' }}>

        <form onSubmit={handleSubmit}>
            {
                getFieldDecorator('company', {
                    rules: [{required: true, message: '请输入工作单位'}],
                    initialValue: undefined
                })(<Input label='工作单位' type={'text'} placeholder='请输入工作单位'
                          extraClass={['no-border-top', 'fill-width']}
                          clear/>)
            }
            {
                getFieldDecorator('post', {
                    rules: [{required: true, message: '请输入职位名称'}],
                    initialValue: undefined
                })(<Input label='职位名称' type={'text'} placeholder='请输入职位名称'
                          extraClass={['no-border-top', 'fill-width']}
                          clear/>)
            }
            {
                getFieldDecorator('start', {
                    rules: [{required: true, message: '请选择开始日期'}],
                    initialValue: undefined
                })(<DatePickerBox DateConfig={dateConfig} label={'开始日期'}/>)
            }
            {
                getFieldDecorator('end', {
                    rules: [{required: true, message: '请输入结束日期'}],
                    initialValue: undefined
                })(<DatePickerBox DateConfig={dateConfig} label={'结束日期'}/>)
            }
            {
                getFieldDecorator('content', {
                    rules: [{required: true, message: '请输入工作内容'}],
                    initialValue: undefined
                })(<Input isTextArea={true} type={'text'} placeholder='请输入工作内容'
                          extraClass={['no-border-top', 'fill-width']}
                          clear/>)
            }
            <button style={{marginLeft: '.3rem', marginRight: '.3rem', width: 'calc(100% - .6rem)'}} type={'submit'}
                    className="common-btn submit">确认
            </button>

        </form>
        {
            params.id && <div className="common-btn delete" onClick={() =>  deleteHandle((params.id as string)) } style={
                {
                    marginLeft: '.3rem',
                    marginRight: '.3rem',
                    width: 'calc(100% - .6rem)',
                    borderRadius:'.1rem',
                    color:"#ff0000",
                    backgroundColor:'transparent',
                    border:'1px solid #ff0000',
                    lineHeight:'.85rem',
                    marginTop:'.3rem'
                }
            }>
                删除简历
            </div>
        }
    </div>
}

export default WorkModal
